<template>
  <div class="dropdown-center">
    <button
      id="dropdowFleetFilters"
      class="form-select form-select-short"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false">
      <div v-if="categories.length" class="form-select-wrapper">
        <div>
          {{ categories.length }}
          <span v-if="categories.length === 1">
            {{ dictionary.filtersSelectedSuffixSingle }}
          </span>
          <span v-else>{{ dictionary.filtersSelectedSuffixMultiple }}</span>
        </div>
        <button
          type="button"
          class="btn btn-clear btn-reset"
          title="Clear"
          @click.stop="resetCategories">
          <i class="icon-close"></i>
        </button>
      </div>
      <div v-else>{{ dictionary.filtersPlaceholder }}</div>
    </button>
    <div class="dropdown-menu" aria-labelledby="dropdowFleetFilters">
      <div class="b-fleet-filters" @click.stop>
        <div class="b-fleet-filters__body mb-20">
          <!-- group -->
          <div class="b-fleet-filters__group-title mb-15">
            {{ filterTransmissionsLabel }}
          </div>
          <ul class="mb-15">
            <li v-for="item in transmissionsOptions" :key="item.value">
              <input
                :id="idPrefix + item.value"
                v-model="transmissionsTemp"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value" />
              <label
                class="form-check-label"
                :for="idPrefix + item.value"
                @click.stop>
                {{ item.text }}
              </label>
            </li>
          </ul>

          <div class="b-fleet-filters__separator mb-15"></div>
          <!-- group -->
          <div class="b-fleet-filters__group-title mb-15">
            {{ filterSpecialCategoriesLabel }}
          </div>
          <ul class="mb-15">
            <li v-for="item in specialCategoriesOptions" :key="item.value">
              <input
                :id="idPrefix + item.value"
                v-model="specialCategoriesTemp"
                class="form-check-input"
                autocomplete="off"
                type="checkbox"
                :value="item.value" />
              <label
                class="form-check-label"
                :for="idPrefix + item.value"
                @click.stop>
                {{ item.text }}
              </label>
            </li>
          </ul>

          <div
            v-if="showGuaranteed"
            class="b-fleet-filters__separator mb-15"></div>
          <!-- group -->
          <div v-if="showGuaranteed" class="b-fleet-filters__group-title mb-15">
            {{ filterSpecialCategoriesLabel }}
          </div>
          <input
            v-if="showGuaranteed"
            id="checkboxGuaranteed"
            v-model="guaranteedTemp"
            class="form-check-input"
            autocomplete="off"
            type="checkbox" />
          <label
            v-if="showGuaranteed"
            class="form-check-label"
            for="checkboxGuaranteed"
            @click.stop>
            {{ dictionary.guaranteedLabel }}
          </label>
        </div>
        <div class="b-fleet-filters__footer">
          <button
            type="button"
            class="btn btn-primary btn-full-width"
            :disabled="isDisabled"
            @click="onClickApply">
            {{ dictionary.buttonApplyFiltersText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { groupBy } from 'lodash'
import { Dropdown } from 'bootstrap'

export default {
  props: {
    types: {
      required: true,
      type: Array,
    },
    selected: {
      required: false,
      type: Array,
      default: () => [],
    },
    vehiclesTypes: {
      required: true,
      type: Array,
    },
    idPrefix: {
      required: false,
      type: String,
      default: '',
    },
    showGuaranteed: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['submit-filters'],
  data() {
    return {
      transmissionsOptions: [],
      specialCategoriesOptions: [],
      transmissions: [],
      transmissionsTemp: [],
      specialCategories: [],
      specialCategoriesTemp: [],
      dropdown: null,

      guaranteed: false,
      guaranteedTemp: false,
    }
  },

  computed: {
    isDisabled() {
      return this.categoriesTemp.length <= 0
    },

    categoriesTemp() {
      if (this.guaranteedTemp) {
        return this.transmissionsTemp
          .concat(this.specialCategoriesTemp)
          .concat(this.guaranteedTemp)
      }
      return this.transmissionsTemp.concat(this.specialCategoriesTemp)
    },

    categories() {
      if (this.guaranteed) {
        return this.transmissions
          .concat(this.specialCategories)
          .concat(this.guaranteed)
      }
      return this.transmissions.concat(this.specialCategories)
    },

    filterTransmissionsLabel() {
      if (!this.transmissionsOptions.length) {
        return ''
      }

      return this.transmissionsOptions[0].group
    },

    filterSpecialCategoriesLabel() {
      if (!this.specialCategoriesOptions.length) {
        return ''
      }

      return this.specialCategoriesOptions[0].group
    },
  },
  mounted() {
    this.setTypes()
    this.setPreselectedValues()

    const dropdownElement = document.querySelector('#dropdowFleetFilters')
    this.dropdown = new Dropdown(dropdownElement)

    // #8586867
    // If the user has chosen filters, but doesn’t apply the filters and then clicks outside the filter area,
    // the filters should get unchecked and re-initiate
    dropdownElement.addEventListener('hidden.bs.dropdown', () => {
      this.$nextTick(() => {
        this.transmissionsTemp = this.transmissions
        this.specialCategoriesTemp = this.specialCategories
        this.guaranteedTemp = this.guaranteed
      })
    })
  },
  methods: {
    resetCategories() {
      this.transmissionsTemp = this.specialCategoriesTemp = []
      this.guaranteed = this.guaranteedTemp = false
      this.onClickApply()
      this.dropdown.hide()
    },

    setTypes() {
      /* eslint-disable no-undef */
      const grouped = _.groupBy(this.types, (car) => car.Grouping)

      this.transmissionsOptions = Object.values(grouped)[0]
        .filter((i) => this.vehiclesTypes.includes(i.CategoryId))
        .map((i) => ({
          value: i.CategoryId,
          text: i.CategoryName,
          group: i.Grouping,
        }))
      this.specialCategoriesOptions = Object.values(grouped)[1]
        .filter((i) => this.vehiclesTypes.includes(i.CategoryId))
        .map((i) => ({
          value: i.CategoryId,
          text: i.CategoryName,
          group: i.Grouping,
        }))
    },

    setPreselectedValues() {
      if (!this.selected.length) {
        return false
      }

      const entries = this.specialCategoriesOptions.filter((i) =>
        this.selected.includes(i.value)
      )

      if (!entries.length) {
        return false
      }

      this.selected.forEach((elem) => {
        this.specialCategoriesTemp.push(elem)
      })

      this.onClickApply()
    },

    onClickApply() {
      // #8586867
      // If the user has chosen filters, but doesn’t apply the filters and then clicks outside the filter area,
      // the filters should get unchecked and re-initiate
      this.transmissions = this.transmissionsTemp
      this.specialCategories = this.specialCategoriesTemp
      this.guaranteed = this.guaranteedTemp

      this.$emit(
        'submit-filters',
        this.categories,
        this.transmissions,
        this.specialCategories,
        this.guaranteed
      )
      this.hideTooltip()
    },

    hideTooltip() {
      const element = document.getElementById('dropdowFleetFilters')
      const dropdown = Dropdown.getOrCreateInstance(element)
      dropdown.hide()
    },
  },
}
</script>
